var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M35.0002 31.6666H5.00016C4.00016 31.6666 3.3335 30.9999 3.3335 29.9999V9.99992C3.3335 8.99992 4.00016 8.33325 5.00016 8.33325H35.0002C36.0002 8.33325 36.6668 8.99992 36.6668 9.99992V29.9999C36.6668 30.9999 36.0002 31.6666 35.0002 31.6666Z",
    fill: "#009EF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0002 8.33325H5.00016C4.50016 8.33325 4.16683 8.5 3.8335 8.83333L18.6668 22.1666C19.5002 22.8333 20.6668 22.8333 21.3335 22.1666L36.1668 8.83333C35.8335 8.5 35.5002 8.33325 35.0002 8.33325Z",
    fill: "#009EF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/EmailIcon.0d1f7ecfcc356719d77c79968bafb1a2.svg";
export { ForwardRef as ReactComponent };